module.exports = {"phase":{"A":["Lower Ground","0","1","2","3","4","5","6","7","Roof"],"B":["Lower Ground","0","1","2","3","4","5","6","7","8","9","Roof"],"C1":["Lower Ground","0","1","2","3","4","5","6","7","Roof"],"C2":["Lower Ground","0","1","2","3","4","5","6","7","8","9","Roof"],"D":["Lower Ground","0","1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","Roof"],"E":["Lower Ground","0","1","2","3","4","5","6","7","8","9","Roof"],"Site Wide":["Other (specify below)"],"Completed Area (Estates)":["Other (specify below)"]}}


//////////////////
// WEBPACK FOOTER
// ./src/data/royalExchange.json
// module id = 126
// module chunks = 0